<template>
    <vx-card
        :collapse-action="collapsable"
        :is-collapsed.sync="isCollapsed"
        :card-border="!isCollapsed"
        class="practice-info bg-light"
        :class="{ active: !isCollapsed && !isDeleted, disabled: isDeleted }"
    >
    </vx-card>
</template>

<script>
import { mapGetters } from 'vuex'
import _color from '@/assets/utils/color.js'

export default {
    name: 'practice-info',
    props: {
        practice: {
            type: Object,
            default: () => {
                return {}
            }
        },
        active: {
            type: Boolean,
            default: false
        },
        collapsable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            practiceModalOpen: false
        }
    },
    computed: {
        ...mapGetters({
            account: 'accounts/current',
            sites: 'accounts/sortedSites'
        }),
        localPractice: {
            get() {
                return this.practice
            },
            set(updatedPractice) {
                this.$store.commit('accounts/SAVE_PRACTICE', updatedPractice)
            }
        },
        isDeleted() {
            return this.practice.isDeleted
        },
        isCollapsed: {
            get() {
                return this.collapsable && !this.active
            },
            set(v) {
                this.$emit('update:active', !v)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.practice-info {
    transition: transform 0.3s ease-in-out !important;
    transform: scale(0.9);
    ::v-deep .vx-card__actions {
        width: 40px !important;
    }
    &.active {
        transform: scale(0.96);
    }
}
.disabled {
    opacity: 0.75;
    cursor: not-allowed;
    pointer-events: none;
}
</style>
